function autoResize() { 
    this.style.height = 'auto'; 
    this.style.height = this.scrollHeight + 'px'; 
}

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".auto-resize").forEach(el => {
    el.addEventListener('input', autoResize, false);
  });
});
